import type { PublicTransfer } from '../types'
import { formatFileSize } from '../crypto'
import { FileIcon } from './FileIcon'

interface CompleteStateProps {
  transfer: PublicTransfer
}

export function CompleteState({ transfer }: CompleteStateProps) {
  const file = transfer.files[0]

  return (
    <div style={{ textAlign: 'center' }}>
      {/* Success icon */}
      <div style={{
        width: '72px',
        height: '72px',
        borderRadius: 'var(--radius-full)',
        background: 'rgba(48, 209, 88, 0.1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto var(--space-lg)',
      }}>
        <svg width="36" height="36" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="10" stroke="var(--success)" strokeWidth="2" />
          <path d="M8 12L11 15L16 9" stroke="var(--success)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>

      <h2 style={{ 
        fontSize: '22px', 
        fontWeight: 600,
        marginBottom: 'var(--space-sm)',
      }}>
        Download Complete
      </h2>
      
      <p style={{ 
        color: 'var(--text-muted)', 
        fontSize: '14px',
        marginBottom: 'var(--space-xl)',
      }}>
        Your file has been decrypted and downloaded
      </p>

      {/* File info */}
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: 'var(--space-md)',
        padding: 'var(--space-md)',
        background: 'var(--bg)',
        borderRadius: 'var(--radius-md)',
        marginBottom: 'var(--space-xl)',
        textAlign: 'left',
      }}>
        <FileIcon filename={file?.name || ''} />
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ 
            fontWeight: 500,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}>
            {file?.name || 'Downloaded file'}
          </div>
          <div style={{ fontSize: '13px', color: 'var(--text-muted)' }}>
            {formatFileSize(transfer.total_size)}
          </div>
        </div>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <path d="M20 6L9 17L4 12" stroke="var(--success)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>

      {/* Security confirmation */}
      <div style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 'var(--space-sm)',
        padding: 'var(--space-md)',
        background: 'rgba(0, 212, 170, 0.05)',
        border: '1px solid rgba(0, 212, 170, 0.2)',
        borderRadius: 'var(--radius-md)',
        textAlign: 'left',
        fontSize: '13px',
        color: 'var(--text-muted)',
      }}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0, marginTop: '2px' }}>
          <path d="M12 22C12 22 20 18 20 12V5L12 2L4 5V12C4 18 12 22 12 22Z" stroke="var(--accent)" strokeWidth="2" strokeLinejoin="round" />
          <path d="M9 12L11 14L15 10" stroke="var(--accent)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <div>
          <strong style={{ color: 'var(--text)', fontWeight: 500 }}>Securely decrypted</strong>
          <p style={{ marginTop: '2px' }}>
            Your file was decrypted entirely in your browser. The decryption key never left your device.
          </p>
        </div>
      </div>

      {/* CTA */}
      <div style={{ marginTop: 'var(--space-xl)' }}>
        <a 
          href="https://carbon.to" 
          className="btn btn-secondary"
          style={{ textDecoration: 'none' }}
        >
          Share files securely with Carbon
        </a>
      </div>
    </div>
  )
}
